const INITIAL_SPECIAL_CHARS_REGEX =  /^[=+\-@;:'"_]+/;

/**
 * Removes initial special characters from a string defined in {@link INITIAL_SPECIAL_CHARS_REGEX}.
 * This is useful for sanitizing input that may start with unwanted characters.
 * @param {string} value The input string to sanitize.
 * @return {string} The sanitized string with initial special characters removed.
 * If the input is empty or undefined, it returns the input as is.
 * @example
 * removeInitialSpecialChars('=+Hello World'); // returns 'Hello World'
 */
const removeInitialSpecialChars = (value: string): string => {
  if (value === null || value === undefined) return '';
  return value.replace(INITIAL_SPECIAL_CHARS_REGEX, '');
}

export {
  INITIAL_SPECIAL_CHARS_REGEX,
  removeInitialSpecialChars
}